export default __webpack_public_path__ + "static/media/轮播首图8.d71392c0.jpg";